import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModuleContainerComponent } from './module-container/module-container.component';
import { ErrorComponent } from './shared/components/error/error.component';
import { ActivateLoginService } from './shared/services/activate-login.service';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(mod => mod.AuthModule)
  },

  // {
  //   path: '',
  //   loadChildren: () => import('./modules/software-configuration/software-configuration.module').then(mod => mod.SoftwareConfigurationModule)
  // },
  // {
  //   path: 'login',
  //   redirectTo: 'auth',
  //   pathMatch: 'full'
  // },

  {
    path: '',
    component: ModuleContainerComponent,
    children: [
      {
        path: 'software-configuration',
        loadChildren: () => import('./modules/software-configuration/software-configuration.module').then(mod => mod.SoftwareConfigurationModule),
        canActivate: [ActivateLoginService]
      },
      {
        path: 'license-management',
        loadChildren: () => import('./modules/license-management/license-management.module').then(mod => mod.LicenseManagementModule),
        canActivate: [ActivateLoginService]
      },
      {
        path: 'pipeline-management',
        loadChildren: () => import('./modules/pipeline-management/pipeline-management.module').then(mod => mod.PipelineManagementModule),
        canActivate: [ActivateLoginService]
      },
    ]
  },

  {
    path: 'logout',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: ErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
